// 고객 링크 액션(rpc) — 첫 인자는 주소의 토큰과 같아야 한다(서버가 맞춰 본다).
import { shareRpc } from "@/api/client";

export const verifyShare = (token: string, last4: string) => shareRpc("s", token, "verifyShare", token, last4);
